<template>
  <div class="flex min-h-screen bg-gradient-to-br from-[#2a0d4f] via-[#1b1240] to-[#0f172a] text-white">
    <Sidebar />
    <main class="flex-1 min-h-screen">
      <router-view />
    </main>
  </div>
</template>
<script>
  import Sidebar from "@/components/admin/Sidebar.vue"

  export default {
    name: 'AdminLayout',
    components: {
      Sidebar
    },
  };
</script>